import { PaperProps } from "@mui/material";
import Paper from "@mui/material/Paper";

export type CorePaperProps = { shadowStyle?: "wide" | "regular"; rounded?: boolean } & Omit<PaperProps, "elevation">;

export default function CorePaper({
	shadowStyle = "regular",
	rounded = true,
	children,
	sx,
	...paperProps
}: CorePaperProps) {
	return (
		<Paper
			{...paperProps}
			elevation={0}
			sx={{
				border: shadowStyle === "regular" ? undefined : "1px solid #F0F0F0",
				borderRadius: rounded ? "7px" : 0,
				boxShadow: shadowStyle === "regular" ? "0 0 5px 0 rgb(0 0 0/20%)" : "4.22px 3.16px 31.63px 0 #0000001A",
				padding: "20px",
				...sx,
			}}
		>
			{children}
		</Paper>
	);
}
